import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/wineStyles'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'wineStyles'

export const metadata = {
  icon: 'align-justify',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const WineStylesListPage = createListPage({ metadata, api, actionCreators, Content })
const WineStylesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { WineStylesListPage, WineStylesDetailPage }
